<template>
    <div>
        <div class="top-img">
            <img src="../../static/images/u574.jpg" alt="">
        </div>
        <div class="breadcrumb-div">
            <div class="FL">
                <img src="../../static/images/u177.png" alt="" class="breadcrumb-img">
            </div>
            <div class="FL breadcrumb-title">
                {{ $t('lang.position') }}：
            </div>
            <div class="FL">
                <a-breadcrumb class="breadcrumb-main">
                    <a-breadcrumb-item> <a href="/">{{ $t('lang.index1') }}</a></a-breadcrumb-item>
                    <a-breadcrumb-item>{{ $t('lang.Qualification') }}</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
        </div>
        <div class="main-div MT30">
            <div class="MT30">
                <div class="FL MT30">
                    <navComponent/>
                </div>
                <div class="FR" style="width: 1080px;">
                    <div class="int-title3 margin-auto font-weight text-align">{{ newInfo.title }}</div>
                    <div class="margin-auto font-weight text-align int-title2">{{ newInfo.time }}</div>
                    <div v-html="newInfo.text" style="padding: 30px;" class="NewsDiv">
                    </div>
                    <div style="padding: 30px;font-size: 16px;">
                        <p v-if="newInfo.lastArticle.id !== 0">{{ $t('lang.Previous') }}：<span class="cursor-pointer"
                                                                                               @click="otherInfo(newInfo.lastArticle.id)">{{
                                newInfo.lastArticle.title
                            }}</span>
                        </p>
                        <p v-if="newInfo.nextArticle.id !== 0">{{ $t('lang.Next') }}：<span class="cursor-pointer"
                                                                                           @click="otherInfo(newInfo.nextArticle.id)">{{
                                newInfo.nextArticle.title
                            }}</span>
                        </p>
                    </div>
                    <div class=" ClearFloat"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navComponent from "@/components/navcomponents";
import {get} from "@/utils";

export default {
    name: "NewInfo",
    components: {
        navComponent
    },
    data() {
        return {
            id: 1,
            newInfo: {
                id: '',
                image: '',
                title: '',
                text: '',
                time: '',
                lastArticle: {
                    id: '',
                    title: '',
                },
                nextArticle: {
                    id: '',
                    title: '',
                },
            },
        }
    },
    mounted() {

        // this.id = Number(this.$route.query.id);
        this.id = parseFloat(this.$route.params.id)
        const box = document.getElementsByTagName('html');
        box[0].scrollTop = 0;
        get('news/getNews', {id: this.id}).then(res => {
            if (!res.data || res.data.id === 0) {
                this.$router.push({path: '/404'}).then(() => {
                });
            }
            this.newInfo = res.data;
            document.title = this.newInfo.title
        }).catch(() => {
        })
    },
    methods: {
        otherInfo(id) {
            get('news/getNews', {id}).then(res => {
                this.newInfo = res.data;
                const box = document.getElementsByTagName('html');
                box[0].scrollTop = 0;
            }).catch(() => {
            })
        },
    }
}
</script>

<style scoped>
.int-title3 {
    font-size: 28px;
    color: #3a8ee6;
    border-bottom: 1px solid #3a8ee6;
}
</style>
